//@flow
import reducer from "./reducers";

import * as commentsOperations from "./operations";
import * as commentsSelectors from "./selectors";

export { commentsOperations, commentsSelectors };

export default reducer;
